import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import AppLoading from "./AppLoading.vue";
import { toRefs } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingWrapper',
  props: {
    loading: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const { loading } = toRefs(props);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "default"),
    (_unref(loading))
      ? (_openBlock(), _createBlock(AppLoading, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})